// extracted by mini-css-extract-plugin
module.exports = {"filters":"Tab_filters__3atR0","secondary":"Tab_secondary__1FvPr","left":"Tab_left__3No-W","center":"Tab_center__3aUMX","right":"Tab_right__2zVmM"};